import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=32c0d110&scoped=true"
import script from "./Points.vue?vue&type=script&lang=js"
export * from "./Points.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c0d110",
  null
  
)

export default component.exports